/**
 * Order service API
 *
 * Contact: 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface RoleShared { 
    id?: number;
    name?: string;
    description?: string;
    privileges?: Array<RoleShared.PrivilegesEnum>;
}
export namespace RoleShared {
    export type PrivilegesEnum = 'MERCHANT_PROFILE_WRITE' | 'MERCHANT_PROFILE_READ' | 'COMPANIES_WRITE' | 'COMPANIES_READ' | 'MEMBERS_WRITE' | 'MEMBERS_READ' | 'ORDER_READ' | 'ORDER_WRITE' | 'CLIENTS_WRITE' | 'CLIENTS_READ' | 'ITEMS_READ' | 'ITEMS_WRITE' | 'REQUESTS_READ' | 'REQUESTS_WRITE' | 'PAGES_WRITE' | 'PAGES_READ' | 'ARTICLES_WRITE' | 'ARTICLES_READ' | 'LOGS_REPORT_READ' | 'DASHBOARD_READ' | 'USER_PROFILE_READ' | 'USER_PROFILE_WRITE' | 'FIN_PRODUCTS_READ' | 'FIN_PRODUCTS_WRITE' | 'ORDER_RETURNS_READ' | 'ORDER_RETURNS_WRITE' | 'AUDIT_USERS_READ' | 'AUDIT_OPERATORS_READ' | 'OPERATORS_READ' | 'OPERATORS_WRITE' | 'ROLES_READ' | 'ROLES_WRITE' | 'TEMPLATES_READ' | 'TEMPLATE_WRITE' | 'BLOCKS_READ' | 'BLOCKS_WRITE' | 'MEDIA_READ' | 'MEDIA_WRITE' | 'REVIEWS_READ' | 'REVIEWS_WRITE' | 'REVIEW_TEMPLATES_READ' | 'REVIEW_TEMPLATES_WRITE' | 'MARKETING_COMPANIES_READ' | 'MARKETING_COMPANIES_WRITE' | 'PROMOCODES_READ' | 'PROMOCODES_WRITE' | 'BNPL_READ' | 'BNPL_WRITE' | 'PARTNER_PRODUCT_READ' | 'PARTNER_PRODUCT_WRITE' | 'NEGOTIATIONS_READ' | 'NEGOTIATIONS_WRITE' | 'TARGET_NOTIFICATIONS_READ' | 'TARGET_NOTIFICATIONS_WRITE' | 'ORDER_SUM_WRITE' | 'BRANCHES_READ' | 'BRANCHES_WRITE' | 'DISPUTES_READ' | 'DISPUTES_WRITE' | 'TAGS_READ' | 'TAGS_WRITE' | 'CATEGORY_COMMISSION_READ' | 'CATEGORY_COMMISSION_WRITE' | 'MERCHANT_COMPANY_WRITE' | 'CATEGORY_READ' | 'CATEGORY_WRITE' | 'PAGE_SEO_TAGS_READ' | 'PAGE_SEO_TAGS_WRITE' | 'SOURCING_OUTPUTS_READ' | 'SOURCING_OUTPUTS_WRITE' | 'SOURCING_INPUTS_READ' | 'SOURCING_INPUTS_WRITE' | 'DISPUTE_SETTINGS_WRITE' | 'TECHNICAL_USER_READ' | 'TECHNICAL_USER_WRITE' | 'USER_REGIONS_READ' | 'USER_REGIONS_WRITE' | 'SEO_WRITE' | 'SEO_READ' | 'PROFILER_READ' | 'PROFILER_WRITE' | 'MARKETPLACE_SETTINGS_READ' | 'MARKETPLACE_SETTINGS_WRITE' | 'INVOICES_TEMPLATES_READ' | 'INVOICES_TEMPLATES_WRITE' | 'DELIVERY_PERIODS_WRITE' | 'DELIVERY_PERIODS_READ' | 'VIEWS_READ' | 'PAYMENT_ATTRIBUTES_READ' | 'PAYMENT_ATTRIBUTES_WRITE' | 'LICENSES_READ' | 'LICENSES_WRITE' | 'NOTIFICATIONS_READ' | 'NOTIFICATIONS_WRITE' | 'COMMENTS_REMOVE' | 'ITEM_RULES_READ' | 'ITEM_RULES_WRITE' | 'FDS_READ' | 'FDS_WRITE' | 'PROMOTIONS_READ' | 'PROMOTIONS_WRITE' | 'MERCHANT_PAYMENT_METHODS_READ' | 'MERCHANT_PAYMENT_METHODS_WRITE' | 'MERCHANT_DELIVERY_METHODS_READ' | 'MERCHANT_DELIVERY_METHODS_WRITE' | 'TENDERS_READ' | 'TENDERS_WRITE' | 'TENDER_OFFERS_READ' | 'TENDER_OFFERS_WRITE' | 'DELIVERY_ORDERS_APPOINT_COURIER' | 'DELIVERY_ORDERS_READ' | 'DELIVERY_ORDERS_WRITE' | 'RELATED_ITEMS_READ' | 'RELATED_ITEMS_WRITE' | 'REFUNDS_READ' | 'REFUNDS_WRITE';
    export const PrivilegesEnum = {
        MERCHANT_PROFILE_WRITE: 'MERCHANT_PROFILE_WRITE' as PrivilegesEnum,
        MERCHANT_PROFILE_READ: 'MERCHANT_PROFILE_READ' as PrivilegesEnum,
        COMPANIES_WRITE: 'COMPANIES_WRITE' as PrivilegesEnum,
        COMPANIES_READ: 'COMPANIES_READ' as PrivilegesEnum,
        MEMBERS_WRITE: 'MEMBERS_WRITE' as PrivilegesEnum,
        MEMBERS_READ: 'MEMBERS_READ' as PrivilegesEnum,
        ORDER_READ: 'ORDER_READ' as PrivilegesEnum,
        ORDER_WRITE: 'ORDER_WRITE' as PrivilegesEnum,
        CLIENTS_WRITE: 'CLIENTS_WRITE' as PrivilegesEnum,
        CLIENTS_READ: 'CLIENTS_READ' as PrivilegesEnum,
        ITEMS_READ: 'ITEMS_READ' as PrivilegesEnum,
        ITEMS_WRITE: 'ITEMS_WRITE' as PrivilegesEnum,
        REQUESTS_READ: 'REQUESTS_READ' as PrivilegesEnum,
        REQUESTS_WRITE: 'REQUESTS_WRITE' as PrivilegesEnum,
        PAGES_WRITE: 'PAGES_WRITE' as PrivilegesEnum,
        PAGES_READ: 'PAGES_READ' as PrivilegesEnum,
        ARTICLES_WRITE: 'ARTICLES_WRITE' as PrivilegesEnum,
        ARTICLES_READ: 'ARTICLES_READ' as PrivilegesEnum,
        LOGS_REPORT_READ: 'LOGS_REPORT_READ' as PrivilegesEnum,
        DASHBOARD_READ: 'DASHBOARD_READ' as PrivilegesEnum,
        USER_PROFILE_READ: 'USER_PROFILE_READ' as PrivilegesEnum,
        USER_PROFILE_WRITE: 'USER_PROFILE_WRITE' as PrivilegesEnum,
        FIN_PRODUCTS_READ: 'FIN_PRODUCTS_READ' as PrivilegesEnum,
        FIN_PRODUCTS_WRITE: 'FIN_PRODUCTS_WRITE' as PrivilegesEnum,
        ORDER_RETURNS_READ: 'ORDER_RETURNS_READ' as PrivilegesEnum,
        ORDER_RETURNS_WRITE: 'ORDER_RETURNS_WRITE' as PrivilegesEnum,
        AUDIT_USERS_READ: 'AUDIT_USERS_READ' as PrivilegesEnum,
        AUDIT_OPERATORS_READ: 'AUDIT_OPERATORS_READ' as PrivilegesEnum,
        OPERATORS_READ: 'OPERATORS_READ' as PrivilegesEnum,
        OPERATORS_WRITE: 'OPERATORS_WRITE' as PrivilegesEnum,
        ROLES_READ: 'ROLES_READ' as PrivilegesEnum,
        ROLES_WRITE: 'ROLES_WRITE' as PrivilegesEnum,
        TEMPLATES_READ: 'TEMPLATES_READ' as PrivilegesEnum,
        TEMPLATE_WRITE: 'TEMPLATE_WRITE' as PrivilegesEnum,
        BLOCKS_READ: 'BLOCKS_READ' as PrivilegesEnum,
        BLOCKS_WRITE: 'BLOCKS_WRITE' as PrivilegesEnum,
        MEDIA_READ: 'MEDIA_READ' as PrivilegesEnum,
        MEDIA_WRITE: 'MEDIA_WRITE' as PrivilegesEnum,
        REVIEWS_READ: 'REVIEWS_READ' as PrivilegesEnum,
        REVIEWS_WRITE: 'REVIEWS_WRITE' as PrivilegesEnum,
        REVIEW_TEMPLATES_READ: 'REVIEW_TEMPLATES_READ' as PrivilegesEnum,
        REVIEW_TEMPLATES_WRITE: 'REVIEW_TEMPLATES_WRITE' as PrivilegesEnum,
        MARKETING_COMPANIES_READ: 'MARKETING_COMPANIES_READ' as PrivilegesEnum,
        MARKETING_COMPANIES_WRITE: 'MARKETING_COMPANIES_WRITE' as PrivilegesEnum,
        PROMOCODES_READ: 'PROMOCODES_READ' as PrivilegesEnum,
        PROMOCODES_WRITE: 'PROMOCODES_WRITE' as PrivilegesEnum,
        BNPL_READ: 'BNPL_READ' as PrivilegesEnum,
        BNPL_WRITE: 'BNPL_WRITE' as PrivilegesEnum,
        PARTNER_PRODUCT_READ: 'PARTNER_PRODUCT_READ' as PrivilegesEnum,
        PARTNER_PRODUCT_WRITE: 'PARTNER_PRODUCT_WRITE' as PrivilegesEnum,
        NEGOTIATIONS_READ: 'NEGOTIATIONS_READ' as PrivilegesEnum,
        NEGOTIATIONS_WRITE: 'NEGOTIATIONS_WRITE' as PrivilegesEnum,
        TARGET_NOTIFICATIONS_READ: 'TARGET_NOTIFICATIONS_READ' as PrivilegesEnum,
        TARGET_NOTIFICATIONS_WRITE: 'TARGET_NOTIFICATIONS_WRITE' as PrivilegesEnum,
        ORDER_SUM_WRITE: 'ORDER_SUM_WRITE' as PrivilegesEnum,
        BRANCHES_READ: 'BRANCHES_READ' as PrivilegesEnum,
        BRANCHES_WRITE: 'BRANCHES_WRITE' as PrivilegesEnum,
        DISPUTES_READ: 'DISPUTES_READ' as PrivilegesEnum,
        DISPUTES_WRITE: 'DISPUTES_WRITE' as PrivilegesEnum,
        TAGS_READ: 'TAGS_READ' as PrivilegesEnum,
        TAGS_WRITE: 'TAGS_WRITE' as PrivilegesEnum,
        CATEGORY_COMMISSION_READ: 'CATEGORY_COMMISSION_READ' as PrivilegesEnum,
        CATEGORY_COMMISSION_WRITE: 'CATEGORY_COMMISSION_WRITE' as PrivilegesEnum,
        MERCHANT_COMPANY_WRITE: 'MERCHANT_COMPANY_WRITE' as PrivilegesEnum,
        CATEGORY_READ: 'CATEGORY_READ' as PrivilegesEnum,
        CATEGORY_WRITE: 'CATEGORY_WRITE' as PrivilegesEnum,
        PAGE_SEO_TAGS_READ: 'PAGE_SEO_TAGS_READ' as PrivilegesEnum,
        PAGE_SEO_TAGS_WRITE: 'PAGE_SEO_TAGS_WRITE' as PrivilegesEnum,
        SOURCING_OUTPUTS_READ: 'SOURCING_OUTPUTS_READ' as PrivilegesEnum,
        SOURCING_OUTPUTS_WRITE: 'SOURCING_OUTPUTS_WRITE' as PrivilegesEnum,
        SOURCING_INPUTS_READ: 'SOURCING_INPUTS_READ' as PrivilegesEnum,
        SOURCING_INPUTS_WRITE: 'SOURCING_INPUTS_WRITE' as PrivilegesEnum,
        DISPUTE_SETTINGS_WRITE: 'DISPUTE_SETTINGS_WRITE' as PrivilegesEnum,
        TECHNICAL_USER_READ: 'TECHNICAL_USER_READ' as PrivilegesEnum,
        TECHNICAL_USER_WRITE: 'TECHNICAL_USER_WRITE' as PrivilegesEnum,
        USER_REGIONS_READ: 'USER_REGIONS_READ' as PrivilegesEnum,
        USER_REGIONS_WRITE: 'USER_REGIONS_WRITE' as PrivilegesEnum,
        SEO_WRITE: 'SEO_WRITE' as PrivilegesEnum,
        SEO_READ: 'SEO_READ' as PrivilegesEnum,
        PROFILER_READ: 'PROFILER_READ' as PrivilegesEnum,
        PROFILER_WRITE: 'PROFILER_WRITE' as PrivilegesEnum,
        MARKETPLACE_SETTINGS_READ: 'MARKETPLACE_SETTINGS_READ' as PrivilegesEnum,
        MARKETPLACE_SETTINGS_WRITE: 'MARKETPLACE_SETTINGS_WRITE' as PrivilegesEnum,
        INVOICES_TEMPLATES_READ: 'INVOICES_TEMPLATES_READ' as PrivilegesEnum,
        INVOICES_TEMPLATES_WRITE: 'INVOICES_TEMPLATES_WRITE' as PrivilegesEnum,
        DELIVERY_PERIODS_WRITE: 'DELIVERY_PERIODS_WRITE' as PrivilegesEnum,
        DELIVERY_PERIODS_READ: 'DELIVERY_PERIODS_READ' as PrivilegesEnum,
        VIEWS_READ: 'VIEWS_READ' as PrivilegesEnum,
        PAYMENT_ATTRIBUTES_READ: 'PAYMENT_ATTRIBUTES_READ' as PrivilegesEnum,
        PAYMENT_ATTRIBUTES_WRITE: 'PAYMENT_ATTRIBUTES_WRITE' as PrivilegesEnum,
        LICENSES_READ: 'LICENSES_READ' as PrivilegesEnum,
        LICENSES_WRITE: 'LICENSES_WRITE' as PrivilegesEnum,
        NOTIFICATIONS_READ: 'NOTIFICATIONS_READ' as PrivilegesEnum,
        NOTIFICATIONS_WRITE: 'NOTIFICATIONS_WRITE' as PrivilegesEnum,
        COMMENTS_REMOVE: 'COMMENTS_REMOVE' as PrivilegesEnum,
        ITEM_RULES_READ: 'ITEM_RULES_READ' as PrivilegesEnum,
        ITEM_RULES_WRITE: 'ITEM_RULES_WRITE' as PrivilegesEnum,
        FDS_READ: 'FDS_READ' as PrivilegesEnum,
        FDS_WRITE: 'FDS_WRITE' as PrivilegesEnum,
        PROMOTIONS_READ: 'PROMOTIONS_READ' as PrivilegesEnum,
        PROMOTIONS_WRITE: 'PROMOTIONS_WRITE' as PrivilegesEnum,
        MERCHANT_PAYMENT_METHODS_READ: 'MERCHANT_PAYMENT_METHODS_READ' as PrivilegesEnum,
        MERCHANT_PAYMENT_METHODS_WRITE: 'MERCHANT_PAYMENT_METHODS_WRITE' as PrivilegesEnum,
        MERCHANT_DELIVERY_METHODS_READ: 'MERCHANT_DELIVERY_METHODS_READ' as PrivilegesEnum,
        MERCHANT_DELIVERY_METHODS_WRITE: 'MERCHANT_DELIVERY_METHODS_WRITE' as PrivilegesEnum,
        TENDERS_READ: 'TENDERS_READ' as PrivilegesEnum,
        TENDERS_WRITE: 'TENDERS_WRITE' as PrivilegesEnum,
        TENDER_OFFERS_READ: 'TENDER_OFFERS_READ' as PrivilegesEnum,
        TENDER_OFFERS_WRITE: 'TENDER_OFFERS_WRITE' as PrivilegesEnum,
        DELIVERY_ORDERS_APPOINT_COURIER: 'DELIVERY_ORDERS_APPOINT_COURIER' as PrivilegesEnum,
        DELIVERY_ORDERS_READ: 'DELIVERY_ORDERS_READ' as PrivilegesEnum,
        DELIVERY_ORDERS_WRITE: 'DELIVERY_ORDERS_WRITE' as PrivilegesEnum,
        RELATED_ITEMS_READ: 'RELATED_ITEMS_READ' as PrivilegesEnum,
        RELATED_ITEMS_WRITE: 'RELATED_ITEMS_WRITE' as PrivilegesEnum,
        REFUNDS_READ: 'REFUNDS_READ' as PrivilegesEnum,
        REFUNDS_WRITE: 'REFUNDS_WRITE' as PrivilegesEnum
    };
}


